import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import * as ROUTES from '../../constants/routes';
import { withFirebase } from '../Firebase';
import './EmailVerif.css';
import Background from "../assets/login_background.svg";
import Logo from "../../assets/loading/logo_zideeUp.png";
import { Fade } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';
import PropTypes from 'prop-types';


class EmailVerif extends Component {

  render() {
    let width = window.innerWidth;
    if (width > 765) {
      return (
        <div className="custom-background">
          <EmailVerifForm />
        </div>)
    } else {
      return (
        <div className="custom-background">
          <EmailVerifFormPhone />
        </div>
      )
    }
  }
}


const INITIAL_STATE = {
  isSent: false,
  error: null,
  errorMessage: null,
  loading: false,
};


class EmailVerifFormBase extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  componentDidMount() {
    document.body.style.background = `url(${Background}) no-repeat center fixed`;
    document.body.style.backgroundSize = "cover";
    this.props.firebase.auth.onAuthStateChanged(async (currentUser) => {

      if (currentUser.emailVerified) {
        this.props.history.push(ROUTES.HOME)
      }
    })
  }

  onSendEmailVerification = () => {
    this.setState({ loading: true })
    this.props.firebase
      .doSendEmailVerification()
      .then(() => {
        this.setState({ isSent: true, loading: false })
      })
      .catch(error => {
        this.setState({ loading: false, error: error })
        switch (error.code) {
          case 'auth/too-many-requests':
            this.setState({ errorMessage: "Envoi échoué : trop de demandes effectuées depuis cet appareil" })
            break;
          default:
            this.setState({ errorMessage: "Envoi échoué : une erreur est survenue" })
        }
      });
  };

  logout = () => {
    this.props.firebase.auth.signOut()
    window.location.replace('/login')
  }

  render() {
    const { error, errorMessage, loading } = this.state
    const { classes } = this.props

    return (
      <div>
        <div className="email-body">
          <div className="vertical-center-row pt-5 mb-5">
            <div className="text-center mb-5">
              <img
                className="logo-img"
                src={Logo}
                alt="logo"
              />
              <div className="catch-line">
                L'espace amélioration continue
              </div>
            </div>
          </div>
          <Fade in={true} timeout={1000}>
            <div className="row vertical-center-row">
              <div className="col" />
              <div className="col">
                <div className="custom-form-verification">
                  <div className="custom-text-manager form-group mt-3">
                    <p className="verification-text">Confirmez votre inscription</p>
                  </div>
                  <div className="d-flex justify-content-center">
                    {loading && <CircularProgress size={35} className={classes.buttonProgress} />}
                  </div>
                  {!error && this.state.isSent === true &&
                    <p className="verification-body">
                      E-mail de confirmation envoyé : consultez vos e-mails
                      (dossier spam inclus) pour trouver votre e-mail de confirmation.
                      Rafraichissez cette page une fois la confirmation effectuée.
                  </p>}
                  {!error && this.state.isSent === false &&
                    <p className="verification-body">
                      Vérifier votre adresse e-mail : consultez vos
                      e-mails (dossier spams inclus) pour confirmer votre inscription
                      ou envoyez un autre e-mail.
                  </p>}
                  {error && <p className="verification-body">{errorMessage}</p>}
                  <div className="mt-5">
                    <div className="verif-buttons">
                      <button
                        className="verification-btn"
                        type="button"
                        onClick={this.onSendEmailVerification}
                        disabled={this.state.loading}
                      >
                        Renvoyer un e-mail de confirmation
                      </button>

                      <button
                        className="verif-deco-button signup-text"
                        onClick={this.logout}>
                        Se déconnecter
                  </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col" />
            </div>
          </Fade>
        </div>

      </div>
    );
  }
}


class EmailVerifFormBasePhone extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  componentDidMount() {
    document.body.style.background = `url(${Background}) no-repeat center fixed`;
    document.body.style.backgroundSize = "cover";
    this.props.firebase.auth.onAuthStateChanged(async (currentUser) => {

      if (currentUser.emailVerified) {
        this.props.history.push(ROUTES.HOME)
      }
    })
  }

  onSendEmailVerification = () => {
    this.setState({ loading: true })
    this.props.firebase
      .doSendEmailVerification()
      .then(() => this.setState({ isSent: true, loading: false }))
      .catch(error => {
        this.setState({ loading: false, error: error })
        switch (error.code) {
          case 'auth/too-many-requests':
            this.setState({ errorMessage: "Envoi échoué : trop de demandes effectuées depuis cet appareil" })
            break;
          default:
            this.setState({ errorMessage: "Envoi échoué : une erreur est survenue" })
        }
      });
  };

  logout = () => {
    this.props.firebase.auth.signOut()
    window.location.replace('/login')
  }

  render() {
    const { error, errorMessage, loading } = this.state
    const { classes } = this.props

    return (
      <>
        <div className="container">

          <div className="row logo-container">
            <img className="signin-logo-mobile" src={Logo} alt="Logo" />
            <div className="catch-line">
              L'espace amélioration continue
            </div>
          </div>

          <div className="row">
            <div className="login-container">
              <Fade in={true} timeout={1000}>
                <form onSubmit={this.onSubmit}>

                  <div className="verif-mobile-container-mobile">

                    <div className="custom-text-manager form-group mt-3 mb-4">
                      <p className="verification-text">Confirmez votre inscription</p>
                    </div>
                    <div className="d-flex justify-content-center">
                      {loading && <CircularProgress size={35} className={classes.buttonProgress} />}
                    </div>
                    {!error && this.state.isSent === true &&
                      <p className="verification-body">
                        E-mail de confirmation envoyé : consultez vos e-mails
                        (dossier spam inclus) pour trouver votre e-mail de confirmation.
                        Rafraichissez cette page une fois la confirmation effectuée.
                      </p>}
                    {!error && this.state.isSent === false &&
                      <p className="verification-body">
                        Vérifier votre adresse e-mail : consultez vos
                        e-mails (dossier spams inclus) pour confirmer votre inscription
                        ou envoyez un autre e-mail.
                      </p>}
                    {error && <p className="verification-body">{errorMessage}</p>}

                    <div className="text-center mt-5">
                      <button
                        className="verification-btn"
                        type="button"
                        onClick={this.onSendEmailVerification}
                        disabled={this.state.loading}
                      >
                        Envoyer un e-mail de confirmation
                      </button>
                      <button
                        className="verif-deco-button signup-text"
                        onClick={this.logout}>
                        Se déconnecter
                  </button>
                    </div>
                  </div>

                </form>
              </Fade>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const styles_loader = theme => ({
  root: {
  },
  buttonProgress: {
    color: '#FFFFFF',
    position: 'relative'
  },
});

EmailVerifFormBase.propTypes = {
  classes: PropTypes.object.isRequired,
};

EmailVerifFormBasePhone.propTypes = {
  classes: PropTypes.object.isRequired,
};

const EmailVerifForm = withRouter(withFirebase(withStyles(styles_loader)(EmailVerifFormBase)));
const EmailVerifFormPhone = withRouter(withFirebase(withStyles(styles_loader)(EmailVerifFormBasePhone)));

export default EmailVerif;
export { EmailVerifForm };